import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Home } from "@/pages/Home";
import { About } from "@/pages/About";
import { Products } from "@/pages/Products";
import { Corporate } from "@/pages/Corporate";
import { PrivacyPolicy } from "@/pages/PrivacyPolicy";
import { TermsOfService } from "@/pages/TermsOfService";
import { CookiePolicy } from "@/pages/CookiePolicy";
import { Disclaimer } from "@/pages/Disclaimer";
import { SpecialtyNotes } from "@/pages/SpecialtyNotes";
import { Contact } from "@/pages/Contact";
import { JMBullion } from "@/pages/retailers/JMBullion";
import { TDPreciousMetals } from "@/pages/retailers/TDPreciousMetals";
import { Layout } from "@/components/Layout";

function App() {
  return (
    <div className="min-h-screen bg-[#050505]">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/corporate" element={<Corporate />} />
            <Route path="/specialty" element={<SpecialtyNotes />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/retailers/jm-bullion" element={<JMBullion />} />
            <Route path="/retailers/td" element={<TDPreciousMetals />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: '#0A0A0A',
            border: '1px solid rgba(212, 175, 55, 0.3)',
            color: '#F5F5F5',
          },
          className: 'goldnote-toast',
        }}
        richColors
      />
    </div>
  );
}

export default App;
